import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index.js'
import route from '@/modules/router.js'
Vue.use(Router)

const router = new Router({
    routes: route
})

function initLogin() {
    return !!Vue.$Config.userinfo.employee_id

}
let userinfoStatus = false

async function initUserinfo() {
    if (userinfoStatus) { return }
    userinfoStatus = true
    if (await store.dispatch('getUserinfo')) {
        return true
    } else {
        return false
    }

}
let hasPermission = false

let initPermission = async () => {
    if (hasPermission) { return }
    hasPermission = true
    await store.dispatch('initPermission')

}
let previousRoute = null;
router.beforeEach(async (to, from, next) => {
    previousRoute = from
    if (to.name === 'login') {
        next()
        return
    }
    // 登录状态
    if (!initLogin()) {
        next({
            name: 'login'
        })
    }
    // 用户信息
    await initUserinfo()
    // 权限配置
    await initPermission()
    if (to.meta.auth) {
        let auth = store.state.permissions[to.meta.auth]
        if (!auth) {
            next('/nopermission')
        }
    }
    next()

})

router.getPreviousRoute = function () {
    return previousRoute;
}

router.afterEach((route) => {
    Vue.$Document.globalLoadingStop()
})

export default router